// import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material';
import Balance from 'components/Balance';
import styled from 'styled-components';
import { Button } from '@pancakeswap/uikit';
import { NavLink } from 'react-router-dom';
import { getDrivenContract } from 'utils/contractHelpers';
import { useWeb3React } from '@web3-react/core';
import { getLockUpAddress } from 'utils/addressHelpers';
import { ethers } from 'ethers';


const StakeButton = styled(NavLink)`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 16px;
  box-shadow: rgb(14 14 44 / 40%) 0px -1px 0px 0px inset;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  /* line-height: 1.5; */
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 48px;
  padding: 0px 24px;
  width: 100%;
  background-color: #00FED9;
  color: black;
  font-weight: bold;
  font-size: 20px;
  ${({ theme }) => theme.mediaQueries.xs} {
    height: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;


export default function ValueLocked({ TVL }) { 
    // const [ TVL, setTVL] = useState(0);
    const { library } = useWeb3React();
      
    return (
        // <Box sx={{ width: { md: '50%', sm: '50%' } }}>

        <Box sx={{ padding: '36px 10px 42px' }}>
            <Box sx={{ fontSize: '30px', color: '#00FED9;', textTransform: 'capitalize', textAlign: 'center' }}>
                Total value locked
            </Box>
            <Box sx={{ my: 6, textAlign: 'center', color: '#B1B3CB' }}>
                <Box>
                    TVL
                </Box>

                <Balance
                    color="white"
                    fontWeight='bold'
                    lineHeight="1.5"
                    display="inline"
                    fontSize="26px"
                    decimals={0}
                    prefix="$"
                    value={TVL}
                    unit=""
                />
            </Box>
            <Box sx={{ my: 5 }}>
                {/* <StakeButton>
                        Staking Pools
                    </StakeButton>{" "} */}
                <StakeButton to='/pool'>
                    Staking Pools
                </StakeButton>
            </Box>
            <Box>
                <StakeButton to='farm'>
                    Farming Pools
                </StakeButton>{" "}
            </Box>
        </Box>
        // </Box>
    );
}
